import { observable, action, runInAction, computed } from 'mobx'
import { message } from 'antd'
import moment from 'moment'
import { json, get } from '../../../utils/ajax'

class BrandStore {

    @observable list
    @observable search
    @observable loading
    @observable pagination
    @observable modal
    @observable forms

    constructor () {
        this.search = {}
        this.pagination = {}
        this.list = []
        this.loading = false
        this.modal = 'hide'
        this.forms = {
            icon: '',
            brandCode: '',
            sertheTime: '',
            defaultName: '',
            defaultDescription: '',
        }
    }

    /**
     *获取选中的品牌
     */
    @computed get checked () {
        return this.list.filter(item => item.checked)
    }

    /**
     *选中或取消选中
     */
    @action
    onImageCardChecked = (id) => {
        const list = this.list.map(item => {
            if (item.id === id) {
                item.checked = !item.checked
            }
            return item
        })
        runInAction(() => {
            this.list = list
        })
    }

    /**
     * 每次更新search框时，回写数据
     * @param values search数据
     */
    @action.bound
    onSearchFieldChange (values) {
        runInAction(() => {
            this.search = values
        })
    }

    /**
     * 查询品牌列表
     * @param page：页面
     */
    @action searchBrandList = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        // 服务器page参数下标从0开始
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        // 构建查询参数
        let search = {}
        Object.keys(this.search).forEach(key => {
            search[`search.${key}`] = this.search[key] ? this.search[key] : ''
        })
        search.page = page
        search.size = 10
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/brands:search`, search)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = res.content.map(item => {
                return {
                    id: item.id,
                    title: item.defaultName,
                    subTitle: item.defaultDescription,
                    checked: false,
                    isable: item.state,
                    image: item.icon,
                }
            })
            this.pagination = {
                total: res.totalElements,
                results: res.size,
                page: res.number + 1,
            }
            this.loading = false
        })
    }

    /**
     *编辑品牌
     */
    @action
    edit = (id) => {
        this.initEdit(id)
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initEdit = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        if (!id) {
            runInAction(() => {
                this.forms = {
                    icon: '',
                    brandCode: '',
                    defaultName: '',
                    defaultDescription: '',
                    // languageBrand: []
                }
                this.loading = false
                this.modal = 'show'
            })
        } else {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/brand/${id}`)
            if (res && res.status === 0) {
                return
            }
            runInAction(() => {
                this.forms = res
                this.loading = false
                this.modal = 'show'
            })
        }
    }

    /**
     *取消编辑
     */
    @action.bound
    cancelEdit () {
        this.loading = false
        this.modal = 'hide'
    }

    @computed get fields () {
        let fields = {
            id: {value: this.forms.id},
            icon: {value: this.forms.icon},
            brandCode: {value: this.forms.brandCode},
            sertheTime: {value: moment(this.forms.sertheTime)},
            defaultName: {value: this.forms.defaultName},
            defaultDescription: {value: this.forms.defaultDescription},
        }
        return fields
    }

    @action.bound
    onEditFieldChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            id: fields.id.value,
            icon: fields.icon.value,
            brandCode: fields.brandCode.value,
            sertheTime: fields.sertheTime.value && fields.sertheTime.value.valueOf(),
            defaultName: fields.defaultName.value,
            defaultDescription: fields.defaultDescription.value,
        }
        this.forms = forms
    }

    /**
     * 新增或修改品牌
     */
    @action submitEdit = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.forms.id) {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/brand`, this.forms)
            if (res && res.status === 0) {
                return
            }
        } else {
            const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/brand/edite`, this.forms)
            let brand = {
                brandId : this.forms.id,
                brandName : this.forms.defaultName
            }
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/combination/updateBrand`,brand)
            if (res && res.status === 0) {
                return
            }
        }
        await this.searchBrandList(this.pagination.page - 1)
        runInAction(() => {
            this.loading = false
            this.modal = 'hide'
        })
    }

    /**
     * 停用
     * @param id role id
     */
    @action disableBrand = async () => {
        runInAction(() => {
            this.loading = true
        })
        let ids = this.checked.map(item => item.id)
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/brand:disable`, ids)
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/carseries/brandDisable`, ids)
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/combination/disableBrand`, ids)
        if (res && res.status === 0) {
            return
        }
        await this.searchBrandList(this.pagination.page - 1)
        runInAction(() => {
            this.loading = false
        })
    }

    /**
     * 启用
     * @param id role id
     */
    @action enableBrand = async () => {
        runInAction(() => {
            this.loading = true
        })
        let ids = this.checked.map(item => item.id)
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/brand:enable`, ids)
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/carseries/brandEnable`, ids)
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/combination/enableBrand`, ids)
        if (res && res.status === 0) {
            return
        }
        await this.searchBrandList(this.pagination.page - 1)
        runInAction(() => {
            this.loading = false
        })
    }

    @action checkDefaultName = async (name) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/brands:search?size=1&&search.defaultName=` + name)
        if (res && res.status === 0) {
            return
        } else {
            if (res.content[0] && res.content[0].id === this.forms.id) {
                return 0
            } else {
                return res.content.length
            }
        }
    }

    @action checkBrandCode = async (code) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/brands:search?size=100&&search.brandCode=` + code)
        if (res && res.status === 0) {
            return
        } else {
            if (res.content[0] && res.content[0].id === this.forms.id) {
                return 0
            } else {
                return res.content.length
            }
        }
    }

    @action imageUpload = (info) => {
        runInAction(() => {
            this.loading = true
        })
        if (info.file.status === 'done') {
            info = info.file.response
            runInAction(() => {
                this.loading = false
            })
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.loading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }
}

export default new BrandStore()


// WEBPACK FOOTER //
// ./src/Backend/common/Brand/store.js